import React, {useEffect, useState} from 'react';
import {getLeadsAPI} from '../services/Leadservice';
import Button from 'react-bootstrap/Button'
import {Container, Modal} from "react-bootstrap";
import '../style/componentstyles.css'
import {useHistory} from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import {getUserCompany} from "../services/UserService";
import {useAuth} from "../contexts/AuthContext";

import LoadingLoginScreen from "./LoadingLoginScreen";
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';


export default function ArchiveGrid(props) {


    const {SearchBar} = Search;

    const history = useHistory();

    const {currentUser} = useAuth();
    const [leads, setLeads] = useState([]);
    const [filteredLeads, setFilteredLeads] = useState([])
    const [company, setCompany] = useState();
    const [loading, setLoading] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const handleShowDelete = () => setShowDelete(true);
    const [edit, setEdit] = useState(false);


    const editLeadButton = () => {


        return (
            <div>

                <Button variant="warning" onClick={() => setEdit(true)}>
                    <span>Hantera</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-trash-fill" viewBox="0 0 16 16">
                        <path
                            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                </Button>
            </div>
        )
    }


    const displayStatus = (cell) => {
        switch (cell) {

            case true:
                return <Button variant="success" disabled>Lead Godkänd</Button>
            case false:
                return <Button variant="danger" disabled>Lead Nekad</Button>
            default:
                return <Button variant="warning" disabled>Ej Behandlad</Button>
        }
    }


    useEffect(() => {
        setLoading(true)
        const getUser = async () => {
            if (currentUser) {
                const res = await getUserCompany(currentUser.uid)
                setCompany(res)
                return res
            }
        }
        getUser()

        const getLeads = async () => {
            const arr = await getLeadsAPI(company, props.value)
            const declinedLeads = arr.filter((lead) => lead.approved === false && lead.deleted === true)
            setLeads(declinedLeads);
            setFilteredLeads(declinedLeads)

        }

        getLeads().catch(onreject => {

        });

        setLoading(false)
    }, [company,])


    const columns = [{
        dataField: 'firstname',
        text: 'Förnamn',
        sort: true,
    },
        {
            dataField: 'lastname',
            text: 'Efternamn',
            sort: true,
        },
        {
            dataField: 'email',
            text: 'E-post',
            sort: true,

        },


        {
            dataField: 'id',
            text: 'Hantera',
            formatter: editLeadButton,
        },
        {
            dataField: 'approved',
            text: 'Status',
            formatter: displayStatus,
            sort: true,
        }];

    const handleCloseEdit = () => {
        setEdit(false)
    }

    const handleRestoreLead = async (cell) => {
        setLoading(true)

        setLoading(false)
    }

    const handleDeleteLead = async (cell) => {
        setLoading(true)

        setLoading(false)
    }

    return (
        <React.Fragment>
            {loading ? (


                <LoadingLoginScreen/>
            ) : (
                <Container fluid className={"ArchiveGrid"}>
<span style={{fontWeight: 'bold'}}>
                        {company}
                    </span>

                    <ToolkitProvider

                        keyField="id"
                        data={filteredLeads}
                        columns={columns}
                        search
                    >
                        {props => (
                            <div>
                                <SearchBar placeholder="Sök" srText={null}
                                           className="SearchBar" {...props.searchProps} />
                                <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                            </div>
                        )}
                    </ToolkitProvider>


                    <Modal show={edit} onHide={handleCloseEdit}>
                        <Modal.Header>
                            <Modal.Title>Hantera Lead</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <span> ta bort</span>
                        </Modal.Body>
                        <Modal.Footer>

                            <Button variant="danger" onClick={handleDeleteLead}>
                                Ta Bort Lead
                            </Button>
                        </Modal.Footer>
                    </Modal>


                </Container>
            )}
        </React.Fragment>
    )


}

